import { Button } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LinkButton: FunctionComponent<Props> = ({
    children,
    className = '',
    isDisabled = false,
    onClick,
    testId = TEST_ID,
    text = ''
}) => {
    const disabledClass = isDisabled ? styles.disabled : '';

    return (
        <Button
            className={`${className} ${styles.linkButton} ${disabledClass}`}
            isDisabled={isDisabled}
            onClick={onClick}
            testId={testId}
            type='button'>
            {children || text}
        </Button>
    );
};

export default LinkButton;
